// extracted by mini-css-extract-plugin
export default {"heading":"BasicInformation_heading__TAPGn","wrapper":"BasicInformation_wrapper__IZ2N3"};